import Swiper, { Navigation } from "swiper";

export default class PropertySlider {
    constructor() {
        this.slider = '.js-property-slider';
        
        this.init();
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            loop:false,
            spaceBetween: 8,
            slidesPerView: 1,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-property-slider-next",
                prevEl: ".js-property-slider-prev",
            },
            on: {
                slideChangeTransitionEnd: function(){
                    document.querySelector('.js-property-slider-index').textContent = this.activeIndex + 1;
                }
            }
        });

    }
}

new PropertySlider;